import React from 'react';
import { ArrowRight } from 'lucide-react';

const CTASection = () => {
  return (
    <section className="py-32" style={{ backgroundColor: '#1a1a1a' }}>
      <div className="container mx-auto px-8">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-xs tracking-[0.3em] mb-8 font-light" style={{ color: '#8b7355' }}>
            YOUR JOURNEY STARTS HERE
          </p>
          
          <h2 
            className="text-3xl md:text-4xl lg:text-5xl font-light leading-tight mb-8"
            style={{ fontFamily: "'Playfair Display', serif", color: '#ffffff' }}
          >
            Ready to break free and
            <br />
            <span className="italic" style={{ color: '#8b7355' }}>build your dream life?</span>
          </h2>
          
          <p className="text-base font-light mb-12 max-w-xl mx-auto" style={{ color: 'rgba(255,255,255,0.7)' }}>
            Join thousands of women who've transformed their lives through digital marketing. Your freedom-based business is waiting.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="https://stan.store/FarzeenDigitalWealth/p/digital-wealth-academy--1sj4lwda"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 text-xs tracking-[0.15em] px-10 py-4 transition-all duration-300 hover:opacity-80"
              style={{ backgroundColor: '#8b7355', color: '#ffffff' }}
            >
              START YOUR JOURNEY
              <ArrowRight size={16} strokeWidth={1.5} />
            </a>
            <a 
              href="https://stan.store/FarzeenDigitalWealth/p/lets-chat-book-your-free-15-min-clarity-call"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 border text-xs tracking-[0.15em] px-10 py-4 transition-all duration-300 hover:bg-white hover:text-[#1a1a1a]"
              style={{ borderColor: 'rgba(255,255,255,0.3)', color: '#ffffff' }}
            >
              BOOK FREE CALL
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
